<footer >
    <div class="container-fluid">
        <p class="copyright">Powered By <strong class="theme-text-color">Mobiloitte Technology</strong>.</p>
    </div>
</footer>
